var map = {
	"./en/en-us.json": 792,
	"./en/newcornerstone-en.json": 2842,
	"./en/scientificConference-en.json": 2459,
	"./en/scientificExplorer-en.json": 8964,
	"./zh/newcornerstone-zh.json": 2962,
	"./zh/scientificConference-zh.json": 7779,
	"./zh/scientificExplorer-zh.json": 6268,
	"./zh/zh-cn.json": 4856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1852;